<template>
  <div class="didacticiel">

    <div class="grid-container content-page">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-6 medium-offset-3 cell center">
          <title-page attrpage="Globulo Quest" baseline="">Inscription de {{ childName }}</title-page>
        </div>
        <div class="small-12 medium-6 medium-offset-3 cell ">


          <div class="box-mascotte">
            <div class="bubble bottom txtleft">
              <carousel :perPage="1" paginationActiveColor="#de2128" navigationEnabled="true" paginationColor="#ccc" :paginationSize="15">
                <slide>
                  Félicitations ! Le compte de {{ childName }} est bien créé. Vous avez dû recevoir un mail avec les prochaines indications à suivre. Pensez à vérifier vos spams si vous n'avez rien reçu.
                  <p>Vous pouvez dès maintenant découvrir votre carnet de bord.</p>
                  <bouton href="dashboard">Aller au carnet de bord</bouton>
                </slide>
              </carousel>
            </div>
            <img src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    components: { TitlePage, Bouton, Carousel, Slide },
    computed: {
      childName() {
        return this.$store.state.subaccounts.child.first_name
      }
    }
  }

</script>
